import React from "react";

const Content = ({ data }) => {
  const { pic, text, full_text } = data;
  console.log(data);
  
  return (
    <div className="feature-card">
      <div className="card-inner">
        <div className="card-front">
          <img src={pic} className="icon" alt={text} />
          <h3>{text}</h3>
        </div>
        <div className="card-back">
          <p>{full_text}</p>
        </div>
      </div>
    </div>
  );
};

export default Content;
